import { render } from "./IconFormArrow.vue?vue&type=template&id=1bb4ec17"
const script = {}

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__